var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "draggable",
            fn: function (props) {
              return _vm._l(_setup.components_show, function (item) {
                return _c(
                  item.component,
                  _vm._b(
                    {
                      key: item.id,
                      tag: "component",
                      on: {
                        close: function ($event) {
                          return _setup.onRemoveComponent(item)
                        },
                      },
                    },
                    "component",
                    { ...props, ...item.attr },
                    false
                  )
                )
              })
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }